export const experienceData = [
    {
        id: 1,
        company: 'IDLC Finance Limited',
        jobtitle: 'Assistant Software Engineer',
        startYear: '08 August 2022 ',
        endYear: ' Continue'
    },

]